module.exports = __webpack_public_path__ + "static/media/no_records.68b15b4a.svg";